import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { SellersPageLayout } from '~/components/routes/sellers/sellers-page-layout'
import { SELLERS_TAB_PERMISSIONS } from '~/components/routes/sellers/tabs'
import { SellersPanel } from '~/components/routes/sellers/SellersPanel'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/sellers/sellers')({
  staticData: {
    permission: SELLERS_TAB_PERMISSIONS.sellers,
  },
  component: SellersTabPage,
})
withRoutePermissions(Route)

function SellersTabPage() {
  return (
    <SellersPageLayout
      activeTab="sellers"
      actions={
        <AuthorizedButtonLink variant="contained" to="/sellers/new">
          <PlusIcon />
          Ajouter un vendeur
        </AuthorizedButtonLink>
      }
    >
      <SellersPanel />
    </SellersPageLayout>
  )
}
